import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';

// Layout components
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

// Pages
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicos" element={<Services />} />
          <Route path="/sobre" element={<About />} />
          <Route path="/trabalhe-conosco" element={<Careers />} />
          <Route path="/contato" element={<Contact />} />
          <Route path="/privacidade" element={<Privacy />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#252624',
              color: '#ffffff',
              border: '1px solid rgba(217, 251, 6, 0.2)',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
